import ReactGA from "react-ga4";

export function eventTrigger(label, category = 'button', action = 'click', nonInteraction = false){
    ReactGA.event({
        category,
        action,
        label,
        nonInteraction,
    });
}